import React from 'react';
import { UQLoader } from '@dev/uniq-ui';

interface FullscreenLoaderProps {
  message?: string;
  animation?: 'spin' | 'clip' | 'spin-rainbow' | 'clip-rainbow' | 'cube' | 'cube-rainbow';
}

const FullscreenLoader: React.FC<FullscreenLoaderProps> = ({ message, animation = 'spin' }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        zIndex: 9999,
      }}
    >
      <UQLoader size="l" animation={animation} />
      {message && (
        <p style={{ marginTop: '2rem', fontSize: '1.125rem', color: '#6b7280' }}>
          {message}
        </p>
      )}
    </div>
  );
};

export default FullscreenLoader;
